import React                from 'react';
import PropTypes            from 'prop-types';

class Icon extends React.Component {
    constructor(props) {
        super(props);
        this.state          = {}
    }

    render() {
        const p             = this.props;
        let tClassNames     = ['ui-icon'];

        if (p.colorType)    tClassNames.push( p.colorType );
        if (p.size)         tClassNames.push(  p.size );
        if (p.icon)         tClassNames.push(  `i-${p.icon}` );
        if (p.className)    Array.prototype.push.apply(tClassNames, p.className.split(' '));
        tClassNames         = [...new Set(tClassNames)];

        return (
            <i 
                className   = { tClassNames.join(" ") }
                onClick     = { p.onClick }
                { ...p.attrs }
            >
                {p.children}
            </i>
        );
    }
}

Icon.propTypes = {
    onClick                : PropTypes.func,
    className              : PropTypes.string,
    icon                   : PropTypes.string,
};

Icon.defaultProps = {
    size                   : '',
    colorType              : 'primary',
    onClick                : () => {},
    className              : '',
};

export default Icon;